import React from 'react'
import { Box, Skeleton, Table, TableHead, TableBody, TableRow, TableCell, useMediaQuery, useTheme } from '@mui/material'

const TableSectionSkeleton = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box sx={{ 
      width: { xs: '100%', md: '40%' }, 
      border: '1px solid #EFEFEF', 
      borderRadius: '16px', 
      p: 2,
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Skeleton variant="text" width={180} height={20} sx={{ mb: 2, mx: 'auto' }} />
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: '60%' }}>
              <Skeleton variant="text" width="80%" height={16} />
            </TableCell>
            <TableCell sx={{ width: '20%' }}>
              <Skeleton variant="text" width="80%" height={16} />
            </TableCell>
            <TableCell sx={{ width: '20%' }}>
              <Skeleton variant="text" width="80%" height={16} />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(isMobile ? 6 : 8)].map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                <Skeleton variant="text" width="70%" height={14} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="60%" height={14} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="50%" height={14} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )
}

export default TableSectionSkeleton